export const DRAFT_EXPIRY_DAYS = 15;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const isPaidRecord = (item = {}) => {
  const normalizedPaymentStatus = String(item?.paymentStatus || item?.PaymentStatus || "").toLowerCase();
  return item?.Payment_Status === true || normalizedPaymentStatus === "paid";
};

export const isExpiredUnpaidDraft = (item = {}, expiryDays = DRAFT_EXPIRY_DAYS) => {
  if (!item || item?.isFilled === true || isPaidRecord(item)) return false;

  const sourceDate = item?.updatedAt || item?.createdAt;
  if (!sourceDate) return false;

  const parsedDate = new Date(sourceDate);
  if (Number.isNaN(parsedDate.getTime())) return false;

  const uploadDayStart = new Date(parsedDate);
  uploadDayStart.setHours(0, 0, 0, 0);

  const expiryStart = new Date(uploadDayStart.getTime() + expiryDays * MS_PER_DAY);
  return Date.now() >= expiryStart.getTime();
};

export const purgeExpiredUnpaidDrafts = async ({
  items = [],
  deleteItem,
  deleteFn,
  expiryDays = DRAFT_EXPIRY_DAYS,
}) => {
  if (!Array.isArray(items) || items.length === 0 || typeof deleteFn !== "function" || !deleteItem) {
    return { activeDrafts: items || [], deletedIds: [] };
  }

  const expired = items.filter((item) => isExpiredUnpaidDraft(item, expiryDays));
  const activeDrafts = items.filter((item) => !isExpiredUnpaidDraft(item, expiryDays));

  if (expired.length === 0) {
    return { activeDrafts, deletedIds: [] };
  }

  await Promise.all(
    expired
      .filter((item) => item?._id)
      .map((item) =>
        deleteFn({
          deleteId: item._id,
          deleteItem,
        })
      )
  );

  return {
    activeDrafts,
    deletedIds: expired.map((item) => item?._id).filter(Boolean),
  };
};
